
















































import EventBus from '../EventBus'
import Vue from 'vue'
import Component from 'vue-class-component'

let timeout: ReturnType<typeof setTimeout>

export interface MessageType {
  message: string;
  subline: string;
  level: string;
  duration: number;
}

@Component
export default class Message extends Vue {
  showMessage = false
  message = ''
  subline = ''
  level = 'error'

  // noinspection JSUnusedGlobalSymbols
  created () {
    EventBus.$on('message', (data: MessageType) => {
      this.message = data.message
      this.subline = data.subline
      this.level = data.level
      this.showMessage = true
      if (timeout) clearTimeout(timeout)
      if ('duration' in data) {
        timeout = setTimeout(() => {
          this.showMessage = false
        }, data.duration)
      }
    })
    EventBus.$on('message-clear', () => {
      this.showMessage = false
      clearTimeout(timeout)
    })
  }

  close () {
    this.showMessage = false
    clearTimeout(timeout)
  }
}
